<template>
    <div class="modal select-none fixed top-0 right-0 bottom-0 left-0 z-50 overflow-x-hidden overflow-y-auto py-0 sm:py-10">
        <div v-on-clickaway="close" :class="{'w-full sm:w-1/2 mx-auto': size === 'half', 'w-full sm:w-1/3 mx-auto': size === 'small'}" class="relative mx-auto z-20" class2="max-w-full">
            <slot />
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

/**
 * @see https://markus.oberlehner.net/blog/popup-overlays-with-vue-router-and-portal-vue/
 */
export default {
  mixins: [
      clickaway
  ],

  props: ['size'],

  data: () => ({
      modalBg: null
  }),

  created() {
    document.addEventListener('keydown', this.handleEscape);
    document.body.classList.add('overflow-hidden');

    const modalBg = document.createElement('div');
    modalBg.classList = 'fixed top-0 right-0 bottom-0 left-0 bg-gray-600 z-20 opacity-75 cursor-pointer';

    this.modalBg = modalBg;

    document.body.appendChild(this.modalBg);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleEscape);
    document.body.classList.remove('overflow-hidden');
    document.body.removeChild(this.modalBg);
  },

  methods: {
    handleEscape($event) {
      $event.stopPropagation();

      if ($event.keyCode == 27) {
        this.close($event);
      }
    },

    close($event) {
      this.$emit('modal-close', $event);
    }
  }
}
</script>
